export default __webpack_public_path__ + "static/media/gatsby-js.a49df786.jpeg";